import React from 'react';
import { Button } from './ui/Button';
import { Phone } from 'lucide-react';
export function FinalCTA() {
  const scrollToForm = () => {
    const formElement = document.getElementById('lead-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-20 bg-primary text-white text-center relative overflow-hidden" data-id="element-43">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-44">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-teal blur-3xl" data-id="element-45"></div>
        <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-gold blur-3xl" data-id="element-46"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-47">
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 text-white" data-id="element-48">
          Ready to plan your group trip?
        </h2>
        <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto" data-id="element-49">
          Let's create an unforgettable experience for your community. Our team
          is ready to help you every step of the way.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-50">
          <Button variant="gold" size="lg" onClick={scrollToForm} className="shadow-lg shadow-gold/20" data-id="element-51">
            Request a Group Proposal
          </Button>
          <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-primary" data-id="element-52">
            <Phone size={18} className="mr-2" data-id="element-53" />
            Call Us: (877) 953-8687
          </Button>
        </div>
      </div>
    </section>;
}